<template>
    <div :class="['page terms',{ off: !pageOn }]">
        <VHeader type="back" @back="exit()" />
        <div class="page-content" v-html="terms">
            
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'terms',
    props: ['terms'],
    mixins: [ pageOn ],
    watch: {
        pageOn ( newValue ) {
            console.log('pageOn Terms',newValue);
        },
        pages ( pages ) {
            clearTimeout(this._pages);
            this._pages = setTimeout(() => {
                this.pages.indexOf('terms') > -1 && ( this.pageOn = true );
            },500)
        }
    },
    computed: {
        pages () { return this.$store.state.pages }
    },
    components: {
        VHeader
    },
    mounted () {
        WebSoc.SEND({ t: 'getTsCs' },terms => {
            this.$el.querySelector('.page-content').innerHTML = terms;
        })
    },
    methods: {
        exit() {
            this.pageOn = false;
            setTimeout(() => {
                this.popPage('terms');
            },500);
        },
        
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
        
    }
}

</script>

<style lang="scss">
.page.terms {
    h1,h2,h3,h4,h5,h6 { color: whitesmoke; margin: 20px 0px 15px 15px; }
    h1 { font-size: 20px; }
    h2,h3,h4,h5,h6 { font-size: 16px; }
    p { color: whitesmoke; }
}
</style>